import { Controller } from "@hotwired/stimulus"

// Toggles the Create Document "Paste text" / "Upload file" source groups.
// The inactive group is hidden AND disabled (not cleared) so a source the
// author switched away from can never be submitted alongside the active one
// -- server-side validation is still the backstop, this just keeps ordinary
// submissions unambiguous. See direct_text_upload_controller for the
// paste-mode error box it clears via the "modechange" event this dispatches.
export default class extends Controller {
  static targets = ["pasteGroup", "uploadGroup", "pasteField", "uploadField"]

  connect() {
    const checked = this.element.querySelector('input[name="source_mode"]:checked')
    this.toggle(checked ? checked.value : "paste")
  }

  select(event) {
    this.toggle(event.target.value)
  }

  toggle(mode) {
    const isPaste = mode === "paste"

    this.pasteGroupTarget.classList.toggle("hidden", !isPaste)
    this.uploadGroupTarget.classList.toggle("hidden", isPaste)

    this.pasteFieldTargets.forEach((el) => { el.disabled = !isPaste })
    this.uploadFieldTargets.forEach((el) => { el.disabled = isPaste })

    this.dispatch("modechange", { detail: { mode } })
  }
}
